import { CellProps, Hooks } from 'react-table';
import { withExcelOptions } from '../DataGridExportMenu';

function useRowActions<T extends Record<string, unknown>>(renderRowAction: (props: { row: unknown }) => JSX.Element) {
  return (hooks: Hooks<T>): void => {
    if (renderRowAction) {
      hooks.visibleColumns.push((columns) => [
        ...columns,
        {
          id: 'Menu',
          Header: 'Menu',
          Cell: ({ row }: CellProps<T>) => renderRowAction({ row }),
          disableSortBy: true,
          disableResizing: true,
          width: 65,
          ...withExcelOptions({
            exportPolicy: 'EXCLUDE',
          }),
        },
      ]);
    }
  };
}

export default useRowActions;
